<header>
  <div class="mx-auto max-w-2xl px-4 py-10 flex justify-center">
    <img src="/images/logo-crb.svg" alt="Logo Croix Rouge Belgique" style="width: 50%; max-width: 300px;">
  </div>
</header>

<div class="mx-auto max-w-2xl px-4 py-10">
  @if (submittedSuccess()) {
    <div
      class="rounded-lg border border-emerald-200 bg-emerald-50 px-6 py-8 text-center text-emerald-900 shadow-sm"
      role="status"
    >
      <p class="text-lg font-semibold">Merci, votre inscription a bien été enregistrée.</p>
      <p class="mt-2 text-sm text-emerald-800">Nous vous recontacterons si nécessaire.</p>
    </div>
  } @else {
    <h1 class="mb-3 text-2xl font-semibold text-slate-900 text-center">
      Formulaire d’inscription – ACTION Grand Coeur
    </h1>

    <p class="mb-8 text-sm text-slate-600 text-center">Les champs marqués d’un astérisque (*) sont obligatoires.</p>

    <form class="space-y-8" [formGroup]="form" (ngSubmit)="onSubmitFormEntreprise()" novalidate>
      <fieldset class="space-y-3">
        <legend class="text-sm font-medium text-slate-700">J’inscris…</legend>
        <div class="grid gap-3 sm:grid-cols-2">
          <label
            class="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50/80 has-[input:checked]:border-red-600 has-[input:checked]:bg-red-50/40 has-[input:checked]:ring-2 has-[input:checked]:ring-red-600/15"
          >
            <input
              id="inscription-company"
              type="radio"
              formControlName="companyType"
              value="company"
              class="h-4 w-4 shrink-0 border-slate-300 accent-red-600"
            />
            <span class="font-medium text-slate-900">Mon entreprise</span>
          </label>
          <label
            class="flex cursor-pointer items-center gap-3 rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm shadow-sm transition-colors hover:border-slate-300 hover:bg-slate-50/80 has-[input:checked]:border-red-600 has-[input:checked]:bg-red-50/40 has-[input:checked]:ring-2 has-[input:checked]:ring-red-600/15"
          >
            <input
              id="inscription-association"
              type="radio"
              formControlName="companyType"
              value="association"
              class="h-4 w-4 shrink-0 border-slate-300 accent-red-600"
            />
            <span class="font-medium text-slate-900">Mon association</span>
          </label>
        </div>
      </fieldset>

      <fieldset class="space-y-4">
        <legend class="text-lg font-medium text-slate-800">
          @if (form.controls.companyType.value === 'association') {
            Association
          } @else {
            Entreprise
          }
        </legend>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700" for="companyName">
            @if (form.controls.companyType.value === 'association') {
              Nom de l'association *
            } @else {
              Nom de l'entreprise *
            }
          </label>
          <input
            id="companyName"
            type="text"
            formControlName="companyName"
            autocomplete="organization"
            class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
            [class.border-red-500]="form.controls.companyName.invalid && form.controls.companyName.touched"
          />
          @if (form.controls.companyName.invalid && form.controls.companyName.touched) {
            <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700" for="address"
            >Adresse (rue et numéro) *</label
          >
          <input
            id="address"
            type="text"
            formControlName="address"
            autocomplete="street-address"
            class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
            [class.border-red-500]="form.controls.address.invalid && form.controls.address.touched"
          />
          @if (form.controls.address.invalid && form.controls.address.touched) {
            <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
          }
        </div>

        <div class="grid gap-4 sm:grid-cols-2">
          <div>
            <label class="mb-1 block text-sm font-medium text-slate-700" for="zip">Code postal *</label>
            <input
              id="zip"
              type="text"
              formControlName="zip"
              autocomplete="postal-code"
              class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
              [class.border-red-500]="
                form.controls.zip.invalid && form.controls.zip.touched
              "
            />
            @if (form.controls.zip.invalid && form.controls.zip.touched) {
              <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
            }
          </div>
          <div>
            <label class="mb-1 block text-sm font-medium text-slate-700" for="city">Localité *</label>
            <input
              id="city"
              type="text"
              formControlName="city"
              autocomplete="address-level2"
              class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
              [class.border-red-500]="form.controls.city.invalid && form.controls.city.touched"
            />
            @if (form.controls.city.invalid && form.controls.city.touched) {
              <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
            }
          </div>
        </div>

        @if (form.controls.companyType.value === 'company') {
          <div>
            <label class="mb-1 block text-sm font-medium text-slate-700" for="numberOfEmployees">
              Nombre de collaborateurs dans l’entreprise *
            </label>
            <input
              id="numberOfEmployees"
              type="number"
              min="1"
              formControlName="numberOfEmployees"
              class="w-full max-w-xs rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
              [class.border-red-500]="
                form.controls.numberOfEmployees.invalid && form.controls.numberOfEmployees.touched
              "
            />
            @if (form.controls.numberOfEmployees.invalid && form.controls.numberOfEmployees.touched) {
              <p class="mt-1 text-sm text-red-600">Indique un nombre entier d’au moins 1.</p>
            }
          </div>
        }
      </fieldset>

      <fieldset class="space-y-4">
        <legend class="text-lg font-medium text-slate-800">Personne de contact</legend>

        <div class="grid gap-4 sm:grid-cols-2">
          <div>
            <label class="mb-1 block text-sm font-medium text-slate-700" for="firstname">Prénom *</label>
            <input
              id="firstname"
              type="text"
              formControlName="firstname"
              autocomplete="given-name"
              class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
              [class.border-red-500]="form.controls.firstname.invalid && form.controls.firstname.touched"
            />
            @if (form.controls.firstname.invalid && form.controls.firstname.touched) {
              <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
            }
          </div>
          <div>
            <label class="mb-1 block text-sm font-medium text-slate-700" for="lastname">Nom *</label>
            <input
              id="lastname"
              type="text"
              formControlName="lastname"
              autocomplete="family-name"
              class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
              [class.border-red-500]="form.controls.lastname.invalid && form.controls.lastname.touched"
            />
            @if (form.controls.lastname.invalid && form.controls.lastname.touched) {
              <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
            }
          </div>
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700" for="telephone">Téléphone *</label>
          <input
            id="telephone"
            type="tel"
            formControlName="telephone"
            autocomplete="tel"
            class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
            [class.border-red-500]="form.controls.telephone.invalid && form.controls.telephone.touched"
          />
          @if (form.controls.telephone.invalid && form.controls.telephone.touched) {
            <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700" for="email">E-mail *</label>
          <input
            id="email"
            type="email"
            formControlName="email"
            autocomplete="email"
            class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
            [class.border-red-500]="form.controls.email.invalid && form.controls.email.touched"
          />
          @if (form.controls.email.hasError('required') && form.controls.email.touched) {
            <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
          } @else if (form.controls.email.hasError('email') && form.controls.email.touched) {
            <p class="mt-1 text-sm text-red-600">Adresse e-mail invalide.</p>
          }
        </div>

        <div>
          <label class="mb-1 block text-sm font-medium text-slate-700" for="comments">Commentaires *</label>
          <textarea
            id="comments"
            formControlName="comments"
            rows="5"
            class="w-full rounded-md border border-slate-300 px-3 py-2 text-slate-900 shadow-sm focus:border-red-600 focus:outline-none focus:ring-2 focus:ring-red-600/20"
            [class.border-red-500]="
              form.controls.comments.invalid && form.controls.comments.touched
            "
          ></textarea>
          @if (form.controls.comments.invalid && form.controls.comments.touched) {
            <p class="mt-1 text-sm text-red-600">Ce champ est requis.</p>
          }
        </div>
      </fieldset>

      <div class="rounded-md border border-slate-200 bg-slate-50 p-4">
        <label class="flex cursor-pointer gap-3 text-sm text-slate-800">
          <input
            type="checkbox"
            formControlName="acceptDonnees"
            class="mt-1 size-4 shrink-0 rounded border-slate-300 text-red-600 focus:ring-red-600"
          />
          <span>
            En cochant cette case, vous acceptez la manière dont vos données sont traitées.
            <a
              href="https://www.croix-rouge.be/donnees-personnelles/"
              class="font-medium text-red-700 underline hover:text-red-800"
              target="_blank"
              rel="noopener noreferrer"
              >En savoir plus</a
            >.
          </span>
        </label>
        @if (form.controls.acceptDonnees.invalid && form.controls.acceptDonnees.touched) {
          <p class="mt-2 text-sm text-red-600">Vous devez accepter le traitement des données pour continuer.</p>
        }
      </div>

      @if (apiError()) {
        <div
          class="rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
          role="alert"
        >
          {{ apiError() }}
        </div>
      }

      <div class="flex justify-end">
        <button
          type="submit"
          class="inline-flex min-w-[8rem] items-center justify-center rounded-md bg-red-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-600 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-60"
          [disabled]="submitting()"
        >
          @if (submitting()) {
            <span>Envoi…</span>
          } @else {
            <span>Envoyer</span>
          }
        </button>
      </div>
    </form>
  }
</div>